import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap('8px'),
  },
  label: {
    fontSize: '12px',
    fontWeight: tokens.fontWeightSemibold,
  },
  helperText: {
    color: tokens.colorNeutralForeground3,
    fontSize: '11px',
    lineHeight: '16px',
  },
  comboboxContainer: {
    position: 'relative',
    width: '100%',
  },
  searchIcon: {
    position: 'absolute',
    top: '50%',
    left: '10px',
    zIndex: 1,
    color: tokens.colorNeutralForeground3,
    pointerEvents: 'none',
    transform: 'translateY(-50%)',
  },
  policyCombobox: {
    width: '100%',
    minWidth: 0,
  },
  policyComboboxInput: {
    paddingLeft: '32px',
  },
  policyOptionsList: {
    maxHeight: 'none',
    overflowY: 'visible',
  },
  policyOptionAvailable: {
    fontWeight: tokens.fontWeightSemibold,
  },
  selectedPolicies: {
    minHeight: '30px',
    display: 'flex',
    alignItems: 'flex-start',
    minWidth: 0,
    width: '100%',
  },
  selectedPolicyTags: {
    display: 'flex',
    flexWrap: 'wrap',
    ...shorthands.gap('4px'),
    maxWidth: '100%',
    minWidth: 0,
  },
  selectedPolicyTag: {
    flexShrink: 1,
    maxWidth: '100%',
    minWidth: 0,
  },
  selectedPolicyTagPrimary: {
    minWidth: 0,
    overflowWrap: 'anywhere',
    whiteSpace: 'normal',
  },
  emptySelection: {
    color: tokens.colorNeutralForeground3,
    fontSize: '12px',
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap('8px'),
    minHeight: '32px',
  },
  error: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap('8px'),
    color: tokens.colorPaletteRedForeground1,
  },
});